import * as tslib_1 from "tslib";
import MailCommandBarView from './MailCommandBarView';
import groupHeaderCommandBarStore from 'owa-group-header-store/lib/store/CommandBarStore';
import GroupHeaderNavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import { LazyGroupFilesHubCommandBar } from 'owa-group-files-hub-view';
import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-mail-strings';
var styles = require('./MailModule.scss');
var GroupCommandBarView = /** @class */ (function (_super) {
    tslib_1.__extends(GroupCommandBarView, _super);
    function GroupCommandBarView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupCommandBarView.prototype.render = function () {
        var currentView = groupHeaderCommandBarStore.navigationButtonSelected;
        var content = null;
        switch (currentView) {
            case GroupHeaderNavigationButton.Email:
                return React.createElement(MailCommandBarView, tslib_1.__assign({}, this.props));
            case GroupHeaderNavigationButton.Files:
                content = React.createElement(LazyGroupFilesHubCommandBar, null);
                break;
            // TODO: add all other cases here
        }
        return (React.createElement("div", { tabIndex: -1, className: styles.commandBar, role: 'region', "aria-label": strings.commandToolbarLabel }, content));
    };
    GroupCommandBarView = tslib_1.__decorate([
        observer
    ], GroupCommandBarView);
    return GroupCommandBarView;
}(React.Component));
export default GroupCommandBarView;
//# sourceMappingURL=GroupCommandBarView.js.map